import analytics from 'commons/tracking/analytics';
import { useAbTestStore } from 'commons/stores/abTest';
import { AbTestVariants } from './abTestFlags';
import { readExperimentAssignments, readVariants } from './abTestCookies';
import { reportExposure } from './kameleoonExposure';

export function listVariants(variants: AbTestVariants) {
  return Object.entries(variants)
    .map(([flag, variant]) => `${flag}:${variant}`)
    .sort();
}

// Runs before app.mount(), so the first render and the first event already know the variant.
export function initAbTests(cookies = document.cookie) {
  const variants = readVariants(cookies);

  useAbTestStore().setVariants(variants);
  analytics.setAbTestVariants(listVariants(variants));
  reportExposure(readExperimentAssignments(cookies));
}
